export default "__VITE_ASSET__DU7s3t2G__"